import { HSLA } from '../../../utils';

export function overrideReservedLabelsColor(
  options: { label: string; isDarkMode: boolean },
  color: HSLA
): HSLA {
  return options.label === '__start__' || options.label === '__end__'
    ? ((options.isDarkMode ? [0, 0, 255, 1] : [0, 0, 0, 1]) as HSLA)
    : color;
}
